import * as i18n from "../i18n.ts";
import { clearTime, format, getWeekRange, isSameDay, toLocaleString } from "./DateUtils.ts";

function dayDiff(now :Date,date :Date){
  return Math.round((clearTime(now).getTime() - clearTime(date).getTime())/(3600000*24));
}
export const deltatime = {

  iso(d :Date) :string{
    return d.toISOString();
  },
  deltaday(date :Date) :string{
    var
      now = new Date(),
      theDayDiff = dayDiff(now,date);

    if(theDayDiff===1){
      return i18n.get('deltatime.yesterday');
    }
    if(theDayDiff===0){
      return i18n.get('deltatime.today');
    }
    if(theDayDiff===-1){
      return i18n.get('deltatime.tomorrow');
    }
    if(theDayDiff<0 && theDayDiff>-7){
      return format(date,'dddd');
    }
    if(now.getFullYear()!=date.getFullYear()){
      return format(date, 'll');
    }
    if(now.getFullYear()===date.getFullYear()){
      return toLocaleString(date,{
        day: "numeric",
        month: "long"
      });
    }else{
      return toLocaleString(date,{dateStyle:"long"});
    }
  },
  longdate(date :Date) :string{
    var
      now = new Date(),
      deltaMinutes = Math.floor((now.getTime()-date.getTime())/60000);

    if(deltaMinutes<2){
      return i18n.get('deltatime.justnow');
    }
    if(deltaMinutes<60){
      return i18n.get('deltatime.minutes',deltaMinutes);
    }
    if(getWeekRange(date).containsToday){
      if(isSameDay(now,date)){
        return toLocaleString(date,{timeStyle:'short'});
      }else{
        return toLocaleString(date,{weekday:"long",hour:"2-digit",minute:"2-digit"});
      }
    }
    var result = toLocaleString(date,{dateStyle:"long",timeStyle:'short'});
    if(now.getFullYear()===date.getFullYear()){
      return result.replace(''+now.getFullYear(),"");
    }else{
      return result;
    }

  },
  duedate(date :Date) :string{

    if(date.getHours()===0 && date.getMinutes()===0){
      return format(date,"ll");
    }else{
      return format(date,"lll");
    }
  },
  daytime(date :Date) :string{
    return format(date,'LT');
  },
  day(date :Date) :string{
    var
      now = new Date(),
      dayDiffCalc = dayDiff(now,date);

    if(now.getFullYear()!==date.getFullYear()){
      return format(date,'ll');
    }

    if(dayDiffCalc===0){
      return i18n.get('deltatime.today');
    }else if(dayDiffCalc===1){
      return i18n.get('deltatime.yesterday');
    }else if(dayDiffCalc>6 || dayDiffCalc<0){
      return toLocaleString(date,{dateStyle:"long"}).replace(''+now.getFullYear(),"");
    }else{
      return format(date,'dddd');
    }
  },
  time(date :Date) :string{
    return format(date,'LT');
  },
  fullDate(date :Date) :string{
    return format(date,'LL');
  }
};
setInterval(function(){
  document.querySelectorAll("*[data-deltatime]").forEach(function(obj){
    var date = new Date(obj.getAttribute("data-deltatime"));
    obj.innerText = (
      deltatime[obj.getAttribute("data-deltatime-format")||"daytime"](date)
    );
  });
},60000);


export function html(date :Date,type :string,extraCss=''){
  if(!date) return '';
  var
    buff = '',
    value= deltatime[type](date),
    worthUpdating = false;
  if(type==='iso' || type==='deltaday'){
    return value;
  }
  buff+='<small ';
  if(worthUpdating){
    buff+='data-deltatime="';
    buff+=date.toISOString();
    buff+='" data-deltatime-format="';
    buff+=type;
    buff+='" ';
  }
  buff += 'style="vertical-align:middle;'+extraCss+'" title="';
  if(type==='day'){
    buff += format(date,'LL');
  }else{
    buff += format(date,'LLL');
  }
  buff += '">';
  buff += value;
  buff += '</small>';

  return buff;
}